import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'

import {useFormUserEventHandler} from 'src/shared/hooks'

import type {Props} from './CreativeBlock.types'
import * as classes from './CreativeBlock@desktop.classes'

export function CreativeBlock({className, style, creativeBlock}: Props): React.ReactElement {
  const handleReachGoal = useFormUserEventHandler()
  return (
    <Grid className={clsx(classes.root, className)} style={style} container>
      {creativeBlock?.link ? (
        <a
          href={creativeBlock?.link}
          onClick={() => {
            handleReachGoal(creativeBlock?.goal)
          }}
          rel="noreferrer"
          target={creativeBlock?.targetBlank ? '_blank' : '_self'}
        >
          <img alt="" className={classes.image} src={creativeBlock?.desktopImageSrc} />
        </a>
      ) : (
        <img alt="" className={classes.image} src={creativeBlock?.desktopImageSrc} />
      )}
    </Grid>
  )
}
